import { type GetFeatureFlagsQueryParams } from '@gonfalon/openapi/operations/getFeatureFlags';

import { creationDateRangeToDate } from './creationDateRangeToDate';
import { omitDisabledFilters } from './deprecatedFilterUtils';
import { evaluatedDateRangeToDate } from './evaluatedDateRangeToDate';
import { type UIFlagFilter, baseLifecycleStatesSchema, staleStatesSchema } from './types';

export function serializeUIFlagFilterForAPI(uiFilter: UIFlagFilter) {
  const filter = omitDisabledFilters(uiFilter);
  const apiFilter: NonNullable<GetFeatureFlagsQueryParams['filter']> = {};
  apiFilter.query = filter.query;
  apiFilter.hasDataExport = filter.hasDataExport;
  apiFilter.hasExperiment = filter.hasExperiment;
  apiFilter.maintainerId = filter.maintainerId;
  apiFilter.maintainerTeamKey = filter.maintainerTeamKey;
  apiFilter.tags = filter.tags;
  apiFilter.type = filter.type;
  apiFilter.sdkAvailability = filter.sdkAvailability;
  apiFilter.guardedRollout = filter.guardedRollout;
  apiFilter.filterEnv = filter.filterEnv;
  apiFilter.view = filter.view;
  apiFilter.status = filter.status;
  // Since the UI contains all potential states
  const validAPIFilterState = baseLifecycleStatesSchema.safeParse(filter.state);
  const validAPIFilterStateStates = staleStatesSchema.safeParse(filter.state);
  apiFilter.state = validAPIFilterState.success ? validAPIFilterState.data : undefined;
  apiFilter.staleStates = validAPIFilterStateStates.success ? validAPIFilterStateStates.data : undefined;
  apiFilter.targeting = filter.targeting;
  apiFilter.contextKindTargeted = filter.contextKindTargeted;
  apiFilter.contextKindsEvaluated = filter.contextKindsEvaluated;
  apiFilter.followerId = filter.followerId;
  apiFilter.applicationEvaluated = filter.applicationEvaluated;
  apiFilter.segmentTargeted = filter.segmentTargeted;
  apiFilter.excludeSettings = filter.excludeSettings;
  apiFilter.applicationEvaluated = filter.applicationEvaluated;
  apiFilter.purpose = filter.purpose;

  if (filter.codeReferences !== undefined) {
    apiFilter.codeReferences = filter.codeReferences ? { min: 1 } : { max: 0 };
  }

  const now = Date.now();

  if (filter.evaluated !== undefined) {
    const evaluatedDate = evaluatedDateRangeToDate(filter.evaluated, now);
    apiFilter.evaluated = evaluatedDate ? { after: evaluatedDate.getTime() } : undefined;
  }

  if (filter.created !== undefined) {
    const createdDate = creationDateRangeToDate(filter.created, now);
    apiFilter.creationDate = createdDate ? { before: createdDate.getTime() } : undefined;
  }

  return apiFilter;
}
